export const SCALE = 1000000;
export const SCALED = 1000000000000000000;
